import type { Tq2QuestionGroupProps } from "../models/tech-form-page.models";

export const Tq2HoldArrangementGroup = ({ children }: Tq2QuestionGroupProps) => (
  <fieldset className="mb-6 rounded-md border p-4">
    <legend className="px-2 text-base font-semibold">Hold arrangement</legend>
    <div className="grid max-w-5xl grid-cols-1 gap-4 md:grid-cols-3">{children}</div>
  </fieldset>
);
